import {API, SETTINGS} from '@spinnaker/core';
import { IDinghyEvent } from '../dinghyEvents';

export class DinghyEventsService {

  public static getEvents(): PromiseLike<IDinghyEvent[]> {
    if (SETTINGS.feature.environmentUUID) {
      API.config.headers['environmentUUID'] = SETTINGS.feature.environmentUUID
    }
    return API.one(`/armory/dinghy/api/v1/event`)
      .get();
  }

}
